import { render, staticRenderFns } from "./AirLeeStaffLogin.vue?vue&type=template&id=06135a6a&scoped=true&"
import script from "./AirLeeStaffLogin.vue?vue&type=script&lang=js&"
export * from "./AirLeeStaffLogin.vue?vue&type=script&lang=js&"
import style0 from "./AirLeeStaffLogin.vue?vue&type=style&index=0&id=06135a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06135a6a",
  null
  
)

export default component.exports